import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_CREDIT } from '@/modules/credit/ticket/router';
import { creditService } from '@/services/credit';
import useVuelidate from '@vuelidate/core';
import { minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useCreditTicketEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: route.params.id,
        name: '',
        amount: 0
    });

    const validations = {
        name: { required },
        amount: { required, numeric, min: minValue(1) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => creditService.ticket.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_CREDIT.TICKET.INDEX })
    });

    const update = crudAction.excuteAndNotify({
        validator: v$,
        request: () => creditService.ticket.update(model.id, model.name, model.amount),
        onSuccess: () => router.push({ name: ROUTE_NAME_CREDIT.TICKET.INDEX })
    });

    return { model, v$, update, fetch };
}
